import React from 'react'

const Footer = () => {
  return (
    <>
    <h4 className='text-center foot' >All rights reserved</h4>
    </>
  )
}

export default Footer